import { Component, HostBinding, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs";
import { BreakpointObserver } from '@angular/cdk/layout';

type AppRoute =
  {
    title: string;
    link: string;
    navigateTo: string[];
    active: boolean;
    icon: string;
  }

@Component({
  selector: 'cpf-small-nav',
  templateUrl: './small-nav.component.html',
  styleUrls: ['./small-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SmallNavComponent implements OnInit {
  appRoutes: AppRoute[] = []

  mobileRoutes: AppRoute[] = [
    {
      title: 'bottom-list-wrapper.nav.my-pets',
      link: '/pet',
      navigateTo: ['calingo', 'pet'],
      active: false,
      icon: 'shield_check'
    },
    {
      title: 'bottom-list-wrapper.nav.claim',
      link: '/fnol',
      navigateTo: ['calingo', 'fnol'],
      active: false,
      icon: 'file_dock'
    },
    {
      title: 'bottom-list-wrapper.nav.chat',
      link: '/telemedicine',
      navigateTo: ['calingo', 'telemedicine', 'chat'],
      active: false,
      icon: 'stethoscope'
    },
    {
      title: 'bottom-list-wrapper.nav.profile',
      link: '/account',
      navigateTo: ['calingo', 'account', 'view'],
      active: false,
      icon: 'user-profile'
    }
  ]

  desktopRoutes: AppRoute[] = [
    {
      title: 'bottom-list-wrapper.nav.my-pets',
      link: '/home',
      navigateTo: ['desktop', 'home'],
      active: false,
      icon: 'shield_check'
    },
    {
      title: 'bottom-list-wrapper.nav.claim-desktop',
      link: '/home/fnol',
      navigateTo: ['desktop', 'home', 'fnol'],
      active: false,
      icon: 'file_dock'
    },
    {
      title: 'bottom-list-wrapper.nav.chat',
      link: '/home/telemedicine',
      navigateTo: ['desktop', 'home', 'telemedicine', 'chat'],
      active: false,
      icon: 'stethoscope'
    },
    {
      title: 'bottom-list-wrapper.nav.profile',
      link: '/home/account',
      navigateTo: ['desktop', 'home', 'account', 'view'],
      active: false,
      icon: 'user-profile'
    }
  ]

  @Input()
  @HostBinding('class.mobile')
  showForMobile = false;

  @HostBinding('class.show')
  show = true;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private breakpointObserver: BreakpointObserver
  ) {
  }

  ngOnInit(): void {
    this.appRoutes = this.showForMobile ? this.mobileRoutes : this.desktopRoutes;
    this.onRouteChange(this.appRoutes);

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.onRouteChange(this.appRoutes);
    });

    this.breakpointObserver.observe([
      '(max-width: 1024px)'
    ]).subscribe(result => {
      this.show = result.matches == this.showForMobile;
    });
  }

  onRouteChange(routes: Array<AppRoute>) {
    routes.forEach(route => route.active = false);
    const currentRoute = this.router.url;
    const activeRoute = routes.filter(route => currentRoute.indexOf(route.link) > -1).at(-1);

    if (!activeRoute) {
      return
    }
    activeRoute.active = true;
  }

  navigateToRoute(routes: Array<AppRoute>, route: AppRoute) {
    if (route.active) {
      return;
    }

    routes.forEach(route => route.active = false);
    route.active = true;

    this.router.navigate(route.navigateTo);
  }
}
